//Khởi tạo thư viện icon của riêng bạn
import { library } from '@fortawesome/fontawesome-svg-core'; 

//Import các icon mà bạn muốn sử dụng trong từng gói
import { faCode, faHighlighter, faCoffee,
      faList, faUser, faKey, faUserEdit,faSpinner,faBasketShopping,faUserShield,faLaptop,faEnvelope,faPalette,faUserGroup,faHouseChimneyUser,faSortDown, faSortUp,faCommentDots,faCircle,faCaretRight,faPhone,faCaretLeft,faCartPlus,faCartArrowDown, faCircleInfo,faQuestionCircle,faBell,faEllipsisVertical,faGlassMartini,faChampagneGlasses,faStar
} from '@fortawesome/free-solid-svg-icons';  


//Add các icon đã được import vào trong thư viện của bạn
library.add( faCode, faHighlighter,
     faCoffee ,faList, faUser,faStar,faCartPlus,faSpinner,faBasketShopping,faUserShield,faLaptop,faPalette,faEnvelope,faUserGroup,faHouseChimneyUser,faSortDown, faSortUp,faCommentDots,faCircle,faPhone,faCaretRight,faCaretLeft,faCartArrowDown, faKey,faUserEdit, faCircleInfo,faQuestionCircle,faBell,faEllipsisVertical,faGlassMartini,faChampagneGlasses
)